"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppButtons = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: ${({ theme }) => theme.Components.AiLogo.Button.Submit};
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  padding: 0 ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
function AppButtons({ labels, status, onClear, onCancel, onSubmit, prompt, isEmbedded = false, view, }) {
    const buttonsState = (0, react_1.useMemo)(() => ({
        shouldRenderCancelButton: isEmbedded
            ? status === 'idle' || view === 'edit'
            : status === 'loading',
        shouldRenderClearButton: (status === 'success' || status === 'error') && !isEmbedded,
        shouldRenderGenerateButton: isEmbedded
            ? status !== 'loading' && view !== 'preview'
            : status === 'idle',
        shouldRenderRegenerateButton: isEmbedded
            ? view === 'preview' && (status === 'success' || status === 'error')
            : status === 'success' || status === 'error',
    }), [isEmbedded, status, view]);
    return ((0, jsx_runtime_1.jsxs)(StyledWrapper, { children: [buttonsState.shouldRenderRegenerateButton && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "outline", icon: { name: 'arrows-circle' }, onClick: () => prompt && onSubmit(prompt), children: labels.regenerateButton })), buttonsState.shouldRenderClearButton && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "outline", onClick: onClear, children: labels.clearButton })), buttonsState.shouldRenderCancelButton && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "secondary", onClick: onCancel, children: labels.cancelButton })), buttonsState.shouldRenderGenerateButton && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "primary", disabled: !prompt, onClick: () => prompt && onSubmit(prompt), children: labels.generateButton }))] }));
}
exports.AppButtons = AppButtons;
//# sourceMappingURL=AppButtons.js.map